let importPromise, highlighterPromise, highlighter;

// Shiki component
export default function () {
    let root,
        rootClassName = '',
        instantiated = false;

    return {
        lang: '',
        theme: '',

        get content() {
            return root.textContent;
        },

        set content(value) {
            root.textContent = value;
        },

        init() {
            root = this.$root;
            rootClassName = root.className;

            Object.assign(this, Helper.parseElementDataset(root));

            if (!importPromise) {
                importPromise = import('https://dev.onsend.io/jsdelivr/npm/shiki@4.0.2/+esm');
            }

            ['lang', 'theme', 'content'].forEach((key) =>
                this.$watch(key, () => {
                    if (Helper.isElementInViewport(root)) {
                        this.render();
                    } else {
                        instantiated = false;
                    }

                    if (key === 'theme') root.className = `${rootClassName} ${this.theme}`;
                })
            );
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            this.render();
        },

        async render() {
            if (!instantiated) return;

            const { createHighlighter, createJavaScriptRegexEngine } = await importPromise;

            if (!highlighterPromise) {
                highlighterPromise = createHighlighter({
                    engine: createJavaScriptRegexEngine(),
                });
            }

            highlighter = await highlighterPromise;

            await Promise.allSettled([highlighter.loadLanguage(this.lang), highlighter.loadTheme(this.theme)]);

            const code = await highlighter.codeToHtml(this.content, {
                lang: this.lang,
                theme: this.theme,
            });

            root.className = `${rootClassName} ${this.theme}`;
            root.innerHTML = document.createRange().createContextualFragment(code).firstElementChild.innerHTML;
        },
    };
}
